import { Divider } from '@mui/material'
import React from 'react'
import './staff.css'
import jeff from './a7.jpeg'
import caleb from './caleb.jpeg'
import clinton from './clinton.jpg'
import derrick from './derrick.jpeg'
import samuel from './samuel.jpg'
import md from './md.jpeg'
import "animate.css/animate.min.css";
// import { AnimationOnScroll } from 'react-animation-on-scroll';
import { motion } from "framer-motion"

export default function Staff() {
  // start page at the top
  window.scrollTo(0, 0)

  const staffData = [
    {
      img: jeff,
      name: "Jefferson Munene K.",
      position: "CEO and Founder",
      testimonial: "Price is what you pay, Value is what you get."
    },
    {
      img: caleb,
      name: "Caleb Mwenda",
      position: "Managing Director",
      testimonial: "Create with the heart; build with the mind."
    },
    {
      img: clinton,
      name: "Clinton Njiru",
      position: "Chief Engineering Officer",
      testimonial: "The best way to predict the future is to create it."
    },
    {
      img: derrick,
      name: "Derrick Otwenyo",
      position: "Director of Business development.",
      testimonial: "Simplicity is the ultimate form of sophistication."
    },
    {
      img: md,
      name: "Troven Sadilas",
      position: "Managing Director(Marketing department)",
      testimonial: "Measure progress — not the time that you're working."
    },
    {
      img: samuel,
      name: "Samuel Mwangi",
      position: "Lead Agent",
      testimonial: "A winner is a dreamer who never gives up."
    }
  ];

  return (
      <div className='staff'>
        <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 1}}
        >
          <div className='head1'>
            <p>Paragon Homes Solutions staff members are professionals responsible for assisting clients in buying,
              selling, and renting properties. We handle tasks such as conducting property viewings, negotiating deals,
              and maintaining relationships with clients. We create excellent communication and interpersonal skills, a
              deep knowledge of the local property market, and the ability to effectively manage their time and
              workload. We make sure to Satisfy our Clients and have strong problem-solving skills.</p>
          </div>
          <Divider/>
          <div className="staff-wrapper">
            <div className="responsive-container-block outer-container">
              <div className="responsive-container-block inner-container">
                <p className="text-blk section-head-text">Our Team</p>
                <p className="text-blk section-subhead-text">Our team is made up of a group of dedicated individuals who
                  are passionate about what they do. We are a small team, but we are a mighty team. We are here to help
                  you find your dream home.</p>
                <div className="responsive-container-block">
                  <div className="swiper team-swiper">
                    <div className="swiper-wrapper">
                      {staffData.map((staff, index) => (
                          <motion.div
                              key={index}
                              initial={{opacity: 0}}
                              animate={{opacity: 1}}
                              exit={{opacity: 0}}
                              transition={{duration: 2}}
                          >
                            <div className="swiper-slide">
                              <div className="card">
                                <div className="img-wrapper">
                                  <img src={staff.img} alt={staff.name}/>
                                </div>
                                <div className="card-content">
                                  <p className="text-blk name">{staff.name}</p>
                                  <p className="text-blk position">{staff.position}</p>
                                  <p className="text-blk testimonial">{staff.testimonial}</p>
                                </div>
                              </div>
                            </div>
                          </motion.div>
                      ))}
                    </div>
                    <div className="swiper-pagination container-block"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
  )
}
